import map from 'lodash/map';
import { arrayOf, number, shape, string } from 'prop-types';
import { taxTextsByCountry } from '../../constants';
import { formatCurrency } from '../utils/currency';
import * as styles from './InvoiceHistory.module.css';

const InvoiceDetails = ({
  creditAppliedInCents,
  discountInCents,
  invoiceNumber,
  lineItems,
  subTotalInCents,
  taxInCents,
  calculatedTotal,
  countryCode,
}) => {
  const taxTexts = taxTextsByCountry(countryCode);
  return (
    <div className={styles.invoiceDetailsContainer}>
      <div className={styles.orderDetails}>
        <h4>Order Details</h4>
      </div>
      {map(lineItems, (item, index) => {
        const { unitAmountInCents, quantity, description } = item;
        return (
          <div
            data-testid="invoice-line-item-row"
            key={`${invoiceNumber}-item-${index}`}
            className={styles.lineItemDetail}
          >
            <div className={styles.invoiceDetails}>
              <div>{description}</div>
              <div>
                <div>{formatCurrency(unitAmountInCents / 100)}</div>
                <div className={styles.itemQuantity}>{`x${quantity}`}</div>
              </div>
            </div>
          </div>
        );
      })}
      <div className={styles.invoiceFinancials}>
        <div className={styles.invoiceFinancialItem}>
          <div>Subtotal</div>
          <div>{formatCurrency(subTotalInCents / 100)}</div>
        </div>
        {discountInCents > 0 && (
          <div className={styles.invoiceFinancialItem}>
            <div>Discount</div>
            <div>{formatCurrency(-discountInCents / 100)}</div>
          </div>
        )}
        {taxInCents > 0 && (
          <div className={styles.invoiceFinancialItem}>
            <div>{`${taxTexts.description}${taxTexts.disclaimer ? '*' : ''}`}</div>
            <div>{formatCurrency(taxInCents / 100)}</div>
          </div>
        )}
        {creditAppliedInCents > 0 && (
          <div className={styles.invoiceFinancialItem}>
            <div>Account Credit</div>
            <div>{formatCurrency(-creditAppliedInCents / 100)}</div>
          </div>
        )}
      </div>
      <div className={styles.orderTotal}>
        <p>Order Total</p>
        <p>{formatCurrency(calculatedTotal)}</p>
      </div>
      {taxInCents > 0 && taxTexts.disclaimer && (
        <div className={styles.invoiceFinancialItem}>
          <div>{taxTexts.disclaimer}</div>
        </div>
      )}
    </div>
  );
};

InvoiceDetails.propTypes = {
  creditAppliedInCents: number.isRequired,
  invoiceNumber: string.isRequired,
  lineItems: arrayOf(shape()).isRequired,
  subTotalInCents: number.isRequired,
  taxInCents: number.isRequired,
  calculatedTotal: number.isRequired,
  countryCode: string.isRequired,
  discountInCents: number,
};

export default InvoiceDetails;
